






































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloMailTemplate, getDefaultAloMailTemplate } from '@/models/alo/AloMailTemplate'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import Edit from '@/components/administration/mailTemplate/edit/EditConfig.vue'

@Component({  
  name: 'GestionMailTemplate',
  components:{Edit} 
})
export default class GestionMailTemplate extends Vue {
  private loading = false
  private showError = false    
  private newMailTemplate = getDefaultAloMailTemplate()

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - 95
  }

  private headers = [
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Titre', value: 'libelle' },
    { text: 'Skin', value: 'mskId' }/*,
    { text: '', value:'actions', width:30, sortable:false,filterable:false}*/
  ]

  private get mailTemplateList() { 
    return this.$store.myGetters.mailTemplateList
  }

  private get mailSkinDic() {
    return this.$store.myGetters.mailSkinDic
  }
  
  private get sortDesc(){
    return this.$store.myGetters.sortMailTemplateDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_MAIL_TEMPLATE_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortMailTemplateBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_MAIL_TEMPLATE_BY(value)
  }  
  
  created() {
    this.loading = true
    this.$store.myActions.ADM_MAIL_SKIN_ENSURE()
    this.$store.myActions.ADM_MAIL_TEMPLATE_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {   
     this.$store.myActions.ADM_MAIL_TEMPLATE_DETAIL_REQUEST(item.id).then(item =>{
       (this.$refs.edit as Edit).edit(item)
     })    
  }

  deleteMailTemplate(mailTemplate:AloMailTemplate) {
     if(mailTemplate.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer le template "${mailTemplate.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_MAIL_TEMPLATE_DELETE_REQUEST(mailTemplate.id)
        } 
      })          
    } 
  }

  addMailTemplate(){    
    this.newMailTemplate = getDefaultAloMailTemplate();
    (this.$refs.edit as Edit).edit(this.newMailTemplate)   
  }
 
}
